export const getAuditControlsByCompanyNameQuery = (companyName: string) => {
    return {
        query: `
    query GetAuditControls($companyName: String!) {
        auditControlsByCompanyName(companyName: $companyName){
        id
        createdAt
        control {
          id
          objective {
            id
            name
            objectiveNumber
          }
          mainSystem {
            id
            system {
              id
              name
              abbreviation
            }
          }
          hrSystem {
            id
            system {
              id
              name
              abbreviation
            }
          }
          ticketSystem {
            id
            system {
              id
              name
              abbreviation
            }
          }
          systemConsolidations
          isCreationEqualsOnboardingApproval
        }
        audit {
          id
          year
          entity {
            id
            name
          }
        }
        controlOwner {
          id
          firstName
          lastName
          email
        }
        controlIt {
          id
          firstName
          lastName
          email
        }
        isHidden
        isAutomated
        status
      }
    }
    `,
        variables: { companyName }
    }
}

// Full query with all control details — used by the add/edit form and execution pipeline
export const getFullAuditControlsByCompanyNameQuery = (companyName: string) => {
    return `
    {
        auditControlsByCompanyName(companyName:"${companyName}"){
        id
        createdAt
        control {
          objective {
            id
            name
          }
          mainSystem {
            id
            system {
              id
              name
            }
            integrationType
          }
          hrSystem {
            id
            system {
              id
              name
            }
            integrationType
          }
          ticketSystem {
            id
            system {
              id
              name
            }
            integrationType
          }
          companyControlId
          systemConsolidations
          consolidationConfig
          systemsArr
          isCreationEqualsOnboardingApproval
        }
        audit {
          id
          year
          entity {
            id
            name
          }
        }
        controlOwner {
          id
          firstName
          lastName
          email
        }
        isHidden
        isAutomated
        status
        controlIt{
          id
          firstName
          lastName
          email
        }
      }
    }
    `
}
